import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export type InterpolationThreshold = [threshold: number, color: string];

export function interpolateColor(
  value: number,
  thresholds: InterpolationThreshold[],
) {
  if (thresholds.length === 0) throw new Error('No thresholds provided');

  value = Math.min(Math.max(value, thresholds[0][0]), thresholds.at(-1)![0]);

  if (value === thresholds[0][0]) return thresholds[0][1];

  for (let i = 0; i < thresholds.length - 1; i++) {
    if (value > thresholds[i + 1][0]) continue;

    const [fromThreshold, fromColor] = thresholds[i];
    const [toThreshold, toColor] = thresholds[i + 1];

    const percentage = (value - fromThreshold) / (toThreshold - fromThreshold);
    return `color-mix(in hsl, ${fromColor}, ${toColor} ${percentage * 100}%)`;
  }
}
